import { createMemo } from "solid-js";
import { locale, setLocale } from "../i18n";

export default function () {
  const title = createMemo(() => {
    const l = locale();
    if (l === "en") {
      return "العربية";
    }
    return "English";
  });
  return (
    <div
      //
      class="flex flex-row w-100px h-40px border-border-input border-1px border-solid py-8px px-12px rounded-md text-14px items-center gap-2 cursor-pointer"
      onclick={() => {
        const l = locale();
        let next = "en";
        if (l === next) {
          next = "ar";
        }
        setLocale(next as any);
      }}
    >
      <span>{title()}</span>
      <i class="i-charm:globe w-20px h-20px text-text-alt" />
    </div>
  );
}
